// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleLayout_root__kIhmT","article":"ArticleLayout_article__3SKaT","articleEnd":"ArticleLayout_articleEnd__ecFby","endMatter":"ArticleLayout_endMatter__3r6F_"};